<template>
  <div id="the-navbar" class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj">
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon"
          @click.stop="showSidebar" />
        <vs-dropdown vs-custom-content vs-trigger-click v-if="!isProject" id="dropdownMargin">
          <vs-button color="warning" class="buttonRadius">
            <span class="span-center">{{ menusDescription }}</span>
            <feather-icon icon="ChevronsDownIcon"></feather-icon>
          </vs-button>
          <vs-dropdown-menu style="min-width: 170px; ">
            <vs-dropdown-item v-on="{click: this.hasPermissions(2) ? showSideBarItemsClinic : () => {}}"
              :disabled="this.hasPermissions(2) ? false : true">Clínicas</vs-dropdown-item>
            <vs-dropdown-item divider v-on="{click: this.hasPermissions(3) ? showSideBarItemsDoctor : () => {}}"
              :disabled="this.hasPermissions(3) ? false : true">Profissionais</vs-dropdown-item>
            <vs-dropdown-item divider v-on="{click: this.hasPermissions(4) ? showSideBarItemsConsultant : () => {}}"
              :disabled="this.hasPermissions(4) ? false : true">Atendimento</vs-dropdown-item>
            <vs-dropdown-item divider v-on="{click: this.hasPermissions(5) ? showSideBarItemsFinancial : () => {}}"
              :disabled="this.hasPermissions(5) ? false : true">Financeiro</vs-dropdown-item>
            <vs-dropdown-item divider v-on="{click: this.hasPermissions(6) ? showSideBarItemsCommercial : () => {}}"
              :disabled="this.hasPermissions(6) ? false : true">Comercial</vs-dropdown-item>
            <vs-dropdown-item divider v-on="{click: this.hasPermissions(8) ? showSideBarItemsTechnology : () => {}}"
              :disabled="this.hasPermissions(8) ? false : true">Tecnologia</vs-dropdown-item>
            <vs-dropdown-item divider v-on="{click: this.hasPermissions(7) ? showSideBarItemsHelpDesk : () => {}}"
              :disabled="this.hasPermissions(7) ? false : true">HelpDesk</vs-dropdown-item>
            <vs-dropdown-item divider v-on="{click: this.hasPermissions(39) ? showSideBarItemsIndicators : () => {}}"
              :disabled="this.hasPermissions(39) ? false : true">Indicadores</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-row type="flex" vs-justify="flex-end">
          <div class="text-right leading-tight sm:block" v-show="breakpoint != 'md'">
            <span>
              <span class="font-semibold">{{ user_displayName }}</span>
              <br />
              <span v-if="type !== undefined" :style="{ fontSize: '10px' }">
                  {{type === "ADMIN" ? "Administrador" : ""}}
              </span>
            </span>
          </div>
          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="con-img ml-3">
              <img v-if="activeUserImg.endsWith('png')" key="onlineImg"
                :src="require(`@/assets/images/portrait/small/${activeUserImg}`)"
                alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
              <img ref="imgProfile" v-else key="localImg" :src="activeUserImg" alt="user-img"
                width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem">
                <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/logout')">
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Sair</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-row>
      </vs-navbar>
    </div>
    <b-modal id="modal-optIn-acceptance" centered hide-footer hide-header no-close-on-esc no-close-on-backdrop>
      <warning-icon></warning-icon>
      <div v-if="mobile" class="w-full mb-4" style="text-align: center;">
        <h4>
          Ao utilizar o portal de gestão você aceita os
          <span class="span-link" @click="toggleFrame(true)">termos e condições de uso</span>.
        </h4>
      </div>
      <div v-else class="w-full mb-4" style="text-align: center;">
        <h4>
          Ao utilizar o portal de gestão você aceita os
          <a :href="termsURL" target="_blank">termos e condições de uso</a>.
        </h4>
      </div>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button type="border" @click="updateOptIn(false)" style="min-width: 135px;">Sair</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button @click="updateOptIn(true)" style="min-width: 135px;">Aceitar</vs-button>
        </vs-col>
      </vs-row>
    </b-modal>
    <b-modal id="modal-use-terms" centered hide-footer hide-header no-close-on-esc no-close-on-backdrop>
      <div style="display: flex; flex-direction: column; align-items: flex-end;">
        <vs-button class="mb-2" @click="toggleFrame(false)" style="width: 50px; padding: 5px 0;">X</vs-button>
        <div style="overflow-y: auto; height:80vh;">
          <horas-term v-if="isProject"></horas-term>
          <filoo-term v-else></filoo-term>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import draggable from "vuedraggable"

import sidebarItems from '@/constants/SidebarItems'
import mixins from "@/Mixins.js"
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue"
import FilooTerm from "@/components/terms/filoo-term/FilooTerm.vue"
import HorasTerm from "@/components/terms/horas-term/HorasTerm.vue"

export default {
  name: "the-navbar",
  mixins: [mixins],
  props: {
    navbarColor: {
      type: String,
      default: "#fff"
    }
  },
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
    FilooTerm,
    HorasTerm
  },
  data() {
    return {
      systems: [],
      colorChipClinics: "warning",
      colorChipDoctors: "warning",
      colorChipConsultant: "warning",
      colorChipFinancial: "warning",
      colorChipCommercial: "warning",
      colorChipHelpDesk: "warning",
      colorChipTechnology: "warning",
      colorChipIndicators: "warning",
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      unreadNotifications: [
        {
          index: 0,
          title: "New Message",
          msg: "Are your going to meet me tonight?",
          icon: "MessageSquareIcon",
          time: this.randomDate({
            sec: 10
          }),
          category: "primary"
        },
        {
          index: 1,
          title: "New Order Recieved",
          msg: "You got new order of goods.",
          icon: "PackageIcon",
          time: this.randomDate({
            sec: 40
          }),
          category: "success"
        },
        {
          index: 2,
          title: "Server Limit Reached!",
          msg: "Server have 99% CPU usage.",
          icon: "AlertOctagonIcon",
          time: this.randomDate({
            min: 1
          }),
          category: "danger"
        },
        {
          index: 3,
          title: "New Mail From Peter",
          msg: "Cake sesame snaps cupcake",
          icon: "MailIcon",
          time: this.randomDate({
            min: 6
          }),
          category: "primary"
        },
        {
          index: 4,
          title: "Bruce's Party",
          msg: "Chocolate cake oat cake tiramisu",
          icon: "CalendarIcon",
          time: this.randomDate({
            hr: 2
          }),
          category: "warning"
        }
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
      menusDescription: "Menus",
      termsURL: "",
      mobile: false
    };
  },
  computed: {
    isProject() {
      return this.$session.get("isProject")
    },

    sidebarWidth() {
      return this.$store.state.sidebarWidth
    },

    breakpoint() {
      return this.$store.state.breakpoint
    },

    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // data() {
    //   return this.$store.state.navbarSearchAndPinList
    // },

    starredPages() {
      return this.$store.state.starredPages
    },

    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10)
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list)
      }
    },
    
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      }
    },

    user_displayName() {
      return this.$session.get("name")
    },

    type() {
      return this.$session.get("type")
    },

    activeUserImg() {
      const photo = this.$session.get("photo")

      return photo
        ? `data:image/png;base64,${photo}`
        : this.$store.state.AppActiveUser.img;
    }
  },
  setup() {
    return {
      sidebarItems,
    }
  },
  created() {
    window.addEventListener("routes-sidebar", this.sidebarRoutes())
    this.sidebarRoutes()
  },
  mounted() {
    this.getSystems(this.$session.get("id"))
    this.getFunc(this.$session.get("id"))

    if (this.isProject) {
      this.showSideBarItemsConsultant()
    }

    this.mobile = this.checkMobile()
  },
  destroyed() {
    window.removeEventListener("routes-sidebar", this.sidebarRoutes())
    this.sidebarRoutes()
  },
  watch: {
    $route() {
      this.sidebarRoutes()

      if (this.showBookmarkPagesDropdown) {
        this.showBookmarkPagesDropdown = false
      }
    }
  },
  methods: {
    sidebarRoutes() {
      if (this.sidebarItems.clinic.includes(this.$store.state.hashPath)) {
        this.clickClinicChip()
      }

      if (this.sidebarItems.doctor.includes(this.$store.state.hashPath)) {
        this.clickDoctorChip();
      }

      if (this.sidebarItems.consultant.includes(this.$store.state.hashPath)) {
        this.clickConsultantChip();
      }

      if (this.sidebarItems.financial.includes(this.$store.state.hashPath)) {
        this.clickFinancialChip();
      }

      if (this.sidebarItems.commercial.includes(this.$store.state.hashPath)) {
        this.clickCommercialChip();
      }

      if (this.sidebarItems.technology.includes(this.$store.state.hashPath)) {
        this.clickTechnologyChip();
      }

      if (this.sidebarItems.helpdesk.includes(this.$store.state.hashPath)) {
        this.clickHelpDeskChip();
      }

      if (this.sidebarItems.indicators.includes(this.$store.state.hashPath)) {
        this.clickIndicatorsChip();
      }
    },
    resetColorChip() {
      this.colorChipClinics = "warning"
      this.colorChipDoctors = "warning"
      this.colorChipConsultant = "warning"
      this.colorChipFinancial = "warning"
      this.colorChipCommercial = "warning"
      this.colorChipTechnology = "warning"
      this.colorChipHelpDesk = "warning"
      this.colorChipIndicators = "warning"
    },
    clickClinicChip() {
      this.resetColorChip()

      this.colorChipClinics = "primary"
      this.menusDescription = "Clínicas"
    },
    clickDoctorChip() {
      this.colorChipDoctors = "primary"
      this.menusDescription = "Profissionais"
    },
    clickConsultantChip() {
      this.resetColorChip()

      this.colorChipConsultant = "primary"
      this.menusDescription = "Atendimento"
    },
    clickFinancialChip() {
      this.resetColorChip()

      this.colorChipFinancial = "primary"
      this.menusDescription = "Financeiro"
    },
    clickCommercialChip() {
      this.resetColorChip()

      this.colorChipCommercial = "primary"
      this.menusDescription = "Comercial"
    },
    clickTechnologyChip() {
      this.resetColorChip()

      this.colorChipTechnology = "primary"
      this.menusDescription = "Tecnologia"
    },
    clickHelpDeskChip() {
      this.resetColorChip()

      this.colorChipHelpDesk = "primary"
      this.menusDescription = "HelpDesk"
    },
    clickIndicatorsChip() {
      this.resetColorChip()

      this.colorChipIndicators = "primary"
      this.menusDescription = "Indicadores"
    },
    getSystems(id) {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })

      this.axios.get(
        `${this.$store.state.filooServer}access/users/${id}/source/gateway`,
        { headers: { Authorization: this.$session.get("bearer")}}
      )
        .then(({status, data}) => {
          if (status === 200) {
            data.systems.forEach(element => {
              this.systems.push(element.id);
            });

            this.$vs.loading.close(this.$refs.content);
          }
        });
    },
    getFunc(id) {
      this.$vs.loading({
        container: this.$refs.content,
        scale: 0.5
      })

      this.axios.get(
        `${this.$store.state.filooServer}access/users/${id}/systems/source/gateway`,
        { headers: {Authorization: this.$session.get("bearer")}}
      )
        .then(({ status, data })=> {
          if (status === 200) {
            //// MOCK2REMOVE
            data.push({
              id: { idUsuario: id, idSistema: 6 },
              nomeFuncionalidade: "Gerenciamento de Especialidades",
              nomeSistema: "Comercial",
              siglaSistema: "COM",
              source: "gateway",
              url: "/specialties-management"
            })
            //// MOCK2REMOVE
            
            const sidebarItemsGrouped = data.reduce((r, a) => {
              r[a.nomeSistema] = [...(r[a.nomeSistema] || []), a]
              return r
            }, {})

            this.$store.commit("PERMISSION_SYSTEM", data.map((obj) => obj.url))
            this.$store.commit("DETAILS_SYSTEMS", sidebarItemsGrouped)
            this.$vs.loading.close(this.$refs.content)
          }
        });
    },
    hasPermissions(systems) {
      return !!this.systems.includes(systems)
    },
    showSideBarItemsDoctor() {
      this.menusDescription = "Profissionais";
      this.$emit("click:button", "doctor");
      this.$router.push("/general-page/doctor");
    },
    showSideBarItemsClinic() {
      this.menusDescription = "Clinicas";
      this.$emit("click:button", "clinic");
      this.$router.push("/general-page/clinic");
    },
    showSideBarItemsConsultant() {
      this.menusDescription = "Atendimento";
      this.$emit("click:button", "consultant");
      this.$router.push("/general-page/consultant");
    },
    showSideBarItemsFinancial() {
      this.menusDescription = "Financeiro";
      this.$emit("click:button", "financial");
      this.$router.push("/general-page/financial");
    },
    showSideBarItemsCommercial() {
      this.menusDescription = "Comercial";
      this.$emit("click:button", "commercial");
      this.$router.push("/general-page/commercial");
    },
    showSideBarItemsTechnology() {
      this.menusDescription = "Tecnologia";
      this.$emit("click:button", "technology");
      this.$router.push("/general-page/technology");
    },
    showSideBarItemsHelpDesk() {
      this.menusDescription = "HelpDesk";
      this.$emit("click:button", "helpdesk");
      this.$router.push("/helpdesk");
    },
    showSideBarItemsIndicators() {
      this.menusDescription = "Indicadores";
      this.$emit("click:button", "indicators");
      this.$router.push("/general-page/indicators");
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true)
    },
    selected(item) {
      this.$router.push(item.url)
      this.showFullSearch = false
    },
    actionClicked(item) {
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction
      })
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ` sec ago` : "just now");
      }

      return "Just Now";
    },
    outside() {
      this.showBookmarkPagesDropdown = false;
    },
    randomDate({ hr, min, sec }) {
      let date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    },
    checkOptIn() {
      if (this.$session.get("optInStatus") !== "ACCEPTED"){
        this.termsURL = this.isProject
          ? "https://www.horasdavida.org.br/termos-de-uso"
          : "https://filoo.com.br/termos-de-uso-paciente"
        this.$bvModal.show("modal-optIn-acceptance")
      }
    },
    updateOptIn(update) {
      this.axios.put(
        `${this.$store.state.filooServer}users/use-terms?accept=${update}`,
        { headers: {Authorization: this.$session.get("bearerDefault")} }
      )
        .then(() =>{
          if (update) {
            this.$session.set("optInStatus", "ACCEPTED")
            this.$bvModal.hide("modal-optIn-acceptance")
          } else {
            this.$router.push("/logout")
          }
        })
        .catch(error => console.log({ error }));
    },
    toggleFrame(check) {
      if (check) {
        this.$bvModal.hide("modal-optIn-acceptance")
        this.$bvModal.show("modal-use-terms")
      } else {
        this.$bvModal.hide("modal-use-terms")
        this.$bvModal.show("modal-optIn-acceptance")
      }
    }
  },
  directives: {
    "click-outside": {
      bind: function(el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function(el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
}
</script>

<style lang="scss">
#the-navbar {
  .buttonsCursorPointer {
    cursor: pointer;
  }

  .font-menu {
    font-size: 14px !important;
  }

  .notActive {
    background: #c3c3c3;
    cursor: default;
  }

  .notActiveIcon {
    background: #c3c3c3;
    cursor: default;
    border: solid 0.5px white;
  }

  .buttonRadius {
    text-align: center;
    padding: 0.8rem 0 !important;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-width: 150px;
  }

  .vs-button-text.vs-button--text {
    display: flex;
  }

  .span-center {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.5vw;
  }

  #dropdownMargin {
    margin-left: 2%;
  }

  .vs-dropdown--custom {
    left: 35%;
  }
}

#modal-optIn-acceptance {
  .span-link {
    color: rgba(var(--vs-primary), 1);
    text-decoration: underline;
  }
}
</style>
